/* Candy4U CANDYPEDIA (id: cpd4q). Rebuilt 2026-09-16 with the Candypedia built to the client's Candypedia Build Brief
   from the Candypedia Entries Master spreadsheet (the Candypedia entry metaobjects). Drives:
     the index (sections/candy-candypedia.liquid): search on the names and the also known as names, the four filters,
       the letters, Random sweet, Sweet of the day and This month's most read
     the entry page (sections/candy-candypedia-article.liquid): the taste bars filling on scroll, the related entries
       fading in, the buy block (sizes, add to basket, the stash heart) and Previous / Next
     the glossary (sections/candy-candypedia-glossary.liquid): the background entries in their groups
     the history (sections/candy-candypedia-history.liquid): the jump menu, the contents list and the scroll depth
   and the GA4 events of brief section 9: entry views, related entry clicks, browse route clicks, random sweet clicks,
   buy block clicks from an entry and scroll depth on the history page.

   The entries come from three Candypedia feed views, at most 400 references per request, and are kept in sessionStorage for the
   tab, so going from the index into entries and back fetches them once. v3 (2026-09-16) is the metaobject feed; v4 the
   same day, when the category lists stopped gluing their first two names together ("MiscRetro"). */
(function(){
  var KEY = 'c4u-cpd-feed-v6';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function(list, fn){ Array.prototype.forEach.call(list, fn); };
  var art = document.querySelector('[data-cpd-article]');
  var pageHandle = art ? art.getAttribute('data-handle') : '';

  /* GA4. The theme carries no GA4 tag of its own: an event goes to gtag (or the dataLayer) when GA4 is on the page, and
     to Shopify's customer events, where a GA4 pixel set up in Settings > Customer events can pass it on. */
  function track(name, params){
    params = params || {};
    try{
      if(typeof window.gtag === 'function') window.gtag('event', name, params);
      else if(window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: name }, params));
    }catch(e){}
    try{ if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, params); }catch(e){}
  }
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest ? e.target.closest('[data-cpd-route],[data-cpd-rel],[data-cpd-buylink]') : null;
    if(!a) return;
    if(a.hasAttribute('data-cpd-route')) track('cpd_route_click', { route: a.getAttribute('data-cpd-route'), value: (a.textContent || '').trim().slice(0, 80), from: pageHandle || window.location.pathname });
    else if(a.hasAttribute('data-cpd-rel')) track('cpd_related_click', { entry: pageHandle, to: a.getAttribute('data-cpd-rel') });
    else track('cpd_buy_click', { entry: pageHandle, action: 'product_page' });
  });

  /* THE FEED IN THREE VIEWS. Liquid hands over only the first 50 items of a metaobject list, a metaobject paginate
     always renders page one however it is asked, and one request that read all 540 entries with their products
     answered 500, so the feed is templates/page.candypedia-feed.liquid, -feed2 and -feed3, eight parts of
     candypedia_list/all-entries each. They are fetched together and kept for the tab. */
  function loadFeed(base){
    try{ var c = sessionStorage.getItem(KEY); if(c) return Promise.resolve(JSON.parse(c)); }catch(e){}
    var urls = [base, base.replace('candypedia-feed', 'candypedia-feed2'), base.replace('candypedia-feed', 'candypedia-feed3')];
    return Promise.all(urls.map(function(u){
      return fetch(u, { credentials: 'same-origin' }).then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    })).then(function(parts){
      var items = [], seen = {};
      parts.forEach(function(p){ items = items.concat((p && p.items) || []); });
      items = items.filter(function(x){ if(!x || !x.h || seen[x.h]) return false; seen[x.h] = 1; return true; });
      items.sort(function(a, b){ return a.t.localeCompare(b.t, 'en', { sensitivity: 'base', numeric: true }); });
      try{ sessionStorage.setItem(KEY, JSON.stringify(items)); }catch(e){}
      return items;
    });
  }
  /* which entries belong to a browse route value */
  function matchRoute(items, kind, val){
    var f = kind === 'decade' ? 'e' : kind === 'country' ? 'n' : kind === 'method' ? 'm' : 'th';
    return items.filter(function(x){
      var v = x[f];
      if(!v) return false;
      return typeof v === 'string' ? v === val : v.indexOf(val) > -1;
    });
  }
  function countText(el, n){
    var one = el.getAttribute('data-count-one') || '1 sweet';
    var many = el.getAttribute('data-count-text') || '[X] sweets';
    return n === 1 ? one : many.replace('[X]', n);
  }
  function esc(s){ return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function letterOf(t){ var ch = String(t || '').trim().charAt(0).toUpperCase(); return /[A-Z]/.test(ch) ? ch : '#'; }
  function groupId(k){ return 'cpd-' + (k === '#' ? 'num' : k); }
  /* the entry card: the photo as a circle, the name, the hook (the same card as snippets/candy-cpd-card.liquid) */
  function card(x){
    return '<a class="custom-cpd4q__ecard" href="' + esc(x.u) + '">'
      + '<span class="custom-cpd4q__ecard-img">' + (x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.t) + '" loading="lazy" decoding="async" width="180" height="180">' : '<span class="custom-cpd4q__ecard-init" aria-hidden="true">' + esc(x.t.charAt(0)) + '</span>') + '</span>'
      + '<span class="custom-cpd4q__ecard-t">' + esc(x.t) + '</span>'
      + (x.k ? '<span class="custom-cpd4q__ecard-k">' + esc(x.k) + '</span>' : '') + '</a>';
  }
  function jumpTo(el, bar, instant){
    var y = el.getBoundingClientRect().top + window.pageYOffset - ((bar && !bar.hidden ? bar.offsetHeight : 0) + 16);
    window.scrollTo({ top: y, behavior: reduce || instant ? 'auto' : 'smooth' });
  }
  /* fill or fade once, as the element scrolls into view; under reduced motion, or with no IntersectionObserver,
     neither class is added and the element simply shows its end state */
  function onceInView(el, cls, threshold){
    if(!el || reduce || !('IntersectionObserver' in window)) return;
    el.classList.add(cls + '--prep');
    var io = new IntersectionObserver(function(es){
      if(!es.some(function(en){ return en.isIntersecting; })) return;
      io.disconnect();
      requestAnimationFrame(function(){ el.classList.add(cls + '--go'); el.classList.remove(cls + '--prep'); });
    }, { threshold: threshold || 0.35 });
    io.observe(el);
  }
  var DIETS = [['vegan', 'Vegan'], ['vegetarian', 'Vegetarian'], ['gluten-free', 'Gluten free'], ['halal', 'Halal'], ['sugar-free', 'Sugar free']];

  /* ================= INDEX ================= */
  var idx = document.querySelector('[data-cpd-index]');
  if(idx){
    var params = new URL(window.location.href).searchParams;
    var by = params.get('by');
    /* Glossary and By decade were chips until 2026-09-15; an old ?by= link lands on their pages */
    if(by === 'decade' || by === 'glossary'){ window.location.replace(by === 'decade' ? '/pages/candypedia-by-decade' : '/pages/candypedia-glossary'); return; }
    var list = idx.querySelector('[data-cpd-list]');
    var q = idx.querySelector('[data-cpd-q]');
    var emptyEl = idx.querySelector('[data-cpd-empty]');
    var note = idx.querySelector('[data-cpd-note]');
    var countEl = idx.querySelector('[data-cpd-count]');
    var lettersNav = idx.querySelector('[data-cpd-letters]');
    var letters = Array.prototype.slice.call(idx.querySelectorAll('[data-letter]'));
    var sels = Array.prototype.slice.call(idx.querySelectorAll('[data-cpd-fsel]'));
    var clearB = idx.querySelector('[data-cpd-fclear]');
    var all = [], sweets = [], term = '', f = { c: '', d: '', e: '', th: '' }, groupsNow = {}, noteT = 0;

    /* the search is the main event, focused on load on desktop (on a phone it would throw the keyboard up) */
    if(q && window.matchMedia('(min-width: 769px)').matches && !window.location.hash){ try{ q.focus({ preventScroll: true }); }catch(e){} }

    var inList = function(arr, v){ return (arr || []).indexOf(v) > -1; };
    function matches(x, t){
      if(t && (x.t + ' ' + (x.a || '')).toLowerCase().indexOf(t) < 0) return false;
      if(f.c && !inList(x.c, f.c)) return false;
      if(f.d && !inList(x.d, f.d)) return false;
      if(f.e && x.e !== f.e) return false;
      if(f.th && !inList(x.th, f.th)) return false;
      return true;
    }
    function render(){
      if(note) note.hidden = true;
      var t = term.trim().toLowerCase();
      /* the A to Z is the sweets; a background entry (an ingredient, a method, a place, a moment) turns up in a search */
      var rows = all.filter(function(x){ return (t || !x.b) && matches(x, t); });
      var groups = {}, order = [];
      rows.forEach(function(x){ var k = letterOf(x.t); if(!groups[k]){ groups[k] = []; order.push(k); } groups[k].push(x); });
      order.sort(function(a, b){ return a === '#' ? -1 : b === '#' ? 1 : (a < b ? -1 : 1); });
      groupsNow = groups;
      list.innerHTML = order.map(function(k){
        return '<section class="custom-cpd4q__group" id="' + groupId(k) + '">'
          + '<h2 class="custom-cpd4q__group-h">' + esc(k) + '<span>' + groups[k].length + '</span></h2>'
          + '<div class="custom-cpd4q__ecards">' + groups[k].map(card).join('') + '</div></section>';
      }).join('');
      emptyEl.hidden = rows.length > 0;
      letters.forEach(function(b){ b.classList.toggle('is-empty', !groups[b.getAttribute('data-letter')]); });
      if(clearB) clearB.hidden = !(f.c || f.d || f.e || f.th);
      sels.forEach(function(s){ s.parentNode.classList.toggle('is-on', !!s.value); ddSync(s); });
    }
    function syncUrl(){
      try{
        var u = new URL(window.location.href);
        ['c', 'd', 'e', 'th'].forEach(function(k){ if(f[k]) u.searchParams.set(k, f[k]); else u.searchParams.delete(k); });
        if(term.trim()) u.searchParams.set('q', term.trim()); else u.searchParams.delete('q');
        history.replaceState(null, '', u.pathname + u.search + u.hash);
      }catch(e){}
    }
    var qT = 0;
    if(q) q.addEventListener('input', function(){ clearTimeout(qT); qT = setTimeout(function(){ term = q.value; render(); syncUrl(); }, 120); });
    sels.forEach(function(s){ s.addEventListener('change', function(){ f[s.getAttribute('data-cpd-fsel')] = s.value; render(); syncUrl(); }); });
    if(clearB) clearB.addEventListener('click', function(){ f = { c: '', d: '', e: '', th: '' }; sels.forEach(function(s){ s.value = ''; }); render(); syncUrl(); });

    /* CUSTOM FILTER DROPDOWNS (user 2026-09-16: "customize"). Each select stays the source of truth: it is hidden, a
       trigger and an option panel are drawn beside it, and picking an option sets the select and fires its own change
       event, so the filtering, the counts and the address above do not change. ddSync redraws a panel from its select
       and is called from render(), which every filter path already goes through. */
    var SEL_OPEN = 'custom-cpd4q__sel--open';
    var fWrap = idx.querySelector('.custom-cpd4q__ifilters');
    function closeSels(keep){
      sels.forEach(function(s){
        var w = s.parentNode;
        if(w === keep || !w.classList.contains(SEL_OPEN)) return;
        w.classList.remove(SEL_OPEN);
        if(w._btn) w._btn.setAttribute('aria-expanded', 'false');
      });
      if(fWrap) fWrap.classList.toggle('custom-cpd4q__ifilters--open', !!keep && keep.classList.contains(SEL_OPEN));
    }
    function ddSync(s){
      var w = s.parentNode;
      if(!w._box) return;
      var cur = s.options[s.selectedIndex];
      w._cur.textContent = s.value && cur ? (cur.getAttribute('data-l') || cur.textContent) : w._name;
      if(w._n !== s.options.length){
        w._n = s.options.length;
        w._box.innerHTML = Array.prototype.map.call(s.options, function(o){
          var n = o.getAttribute('data-n');
          return '<button type="button" role="option" tabindex="-1" class="custom-cpd4q__selopt" data-v="' + esc(o.value) + '"><span>'
            + esc(o.getAttribute('data-l') || o.textContent) + '</span>' + (n ? '<b>' + esc(n) + '</b>' : '') + '</button>';
        }).join('');
      }
      each(w._box.children, function(b){ b.setAttribute('aria-selected', b.getAttribute('data-v') === s.value ? 'true' : 'false'); });
    }
    sels.forEach(function(s){
      var w = s.parentNode;
      w._name = s.options[0] ? s.options[0].textContent : '';
      w.classList.add('custom-cpd4q__sel--dd');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-cpd4q__selbtn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="custom-cpd4q__selcur"></span>';
      var box = document.createElement('div');
      box.className = 'custom-cpd4q__sellist';
      box.setAttribute('role', 'listbox');
      box.setAttribute('aria-label', w._name);
      w.appendChild(btn);
      w.appendChild(box);
      w._btn = btn; w._box = box; w._cur = btn.firstChild;
      btn.addEventListener('click', function(){
        var open = !w.classList.contains(SEL_OPEN);
        w.classList.toggle(SEL_OPEN, open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        closeSels(w);
        if(open){ var on = box.querySelector('[aria-selected="true"]') || box.firstChild; if(on) on.focus({ preventScroll: true }); }
      });
      box.addEventListener('click', function(e){
        var o = e.target.closest('[role="option"]');
        if(!o) return;
        w.classList.remove(SEL_OPEN);
        closeSels(null);
        btn.focus({ preventScroll: true });
        if(s.value === o.getAttribute('data-v')) return;
        s.value = o.getAttribute('data-v');
        s.dispatchEvent(new Event('change'));
      });
      w.addEventListener('keydown', function(e){
        if(!w.classList.contains(SEL_OPEN)) return;
        if(e.key === 'Escape'){ e.preventDefault(); w.classList.remove(SEL_OPEN); closeSels(null); btn.focus(); return; }
        if(e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        var opts = Array.prototype.slice.call(box.children), at = opts.indexOf(document.activeElement);
        var nx = opts[Math.max(0, Math.min(opts.length - 1, at + (e.key === 'ArrowDown' ? 1 : -1)))];
        if(nx) nx.focus();
      });
      ddSync(s);
    });
    document.addEventListener('click', function(e){
      if(e.target.closest && e.target.closest('.' + SEL_OPEN)) return;
      closeSels(null);
    });
    letters.forEach(function(b){
      b.addEventListener('click', function(){
        var l = b.getAttribute('data-letter');
        var sec = document.getElementById(groupId(l));
        if(sec && groupsNow[l]){ if(note) note.hidden = true; jumpTo(sec, lettersNav); }
        else if(note){ note.hidden = false; clearTimeout(noteT); noteT = setTimeout(function(){ note.hidden = true; }, 3200); }
      });
    });

    /* the options of each filter are the values the entries carry, with how many sweets have each */
    function fill(s, pairs){
      pairs.forEach(function(p){
        var o = document.createElement('option');
        o.value = p[0]; o.textContent = p[1] + ' (' + p[2] + ')';
        o.setAttribute('data-l', p[1]); o.setAttribute('data-n', p[2]);   /* name and count, drawn apart in the custom panel */
        s.appendChild(o);
      });
    }
    function tally(fn){
      var m = {};
      sweets.forEach(function(x){ [].concat(fn(x) || []).forEach(function(v){ if(v) m[v] = (m[v] || 0) + 1; }); });
      return m;
    }
    function buildFilters(){
      sels.forEach(function(s){
        var k = s.getAttribute('data-cpd-fsel'), m, pairs;
        if(k === 'c'){ m = tally(function(x){ return x.c; }); pairs = Object.keys(m).sort().map(function(v){ return [v, v, m[v]]; }); }
        else if(k === 'd'){ m = tally(function(x){ return x.d; }); pairs = DIETS.filter(function(d){ return m[d[0]]; }).map(function(d){ return [d[0], d[1], m[d[0]]]; }); }
        else if(k === 'e'){ m = tally(function(x){ return x.e; }); pairs = Object.keys(m).sort(function(a, b){ return parseInt(a, 10) - parseInt(b, 10); }).map(function(v){ return [v, v, m[v]]; }); }
        else { m = tally(function(x){ return x.th; }); pairs = Object.keys(m).sort(function(a, b){ return m[b] - m[a]; }).map(function(v){ return [v, v, m[v]]; }); }
        fill(s, pairs);
        var want = f[k];
        if(want && pairs.some(function(p){ return p[0] === want; })) s.value = want; else f[k] = '';
      });
    }

    var rnd = idx.querySelector('[data-cpd-random]');
    var today = idx.querySelector('[data-cpd-today]');
    var todayName = idx.querySelector('[data-cpd-today-name]');
    /* the same sweet for everyone all day, a new one at midnight UTC */
    var dayPick = function(){ return sweets.length ? sweets[Math.floor(Date.now() / 864e5) % sweets.length] : null; };
    if(rnd) rnd.addEventListener('click', function(){
      if(!sweets.length) return;
      var x = sweets[Math.floor(Math.random() * sweets.length)];
      track('cpd_random_click', { to: x.h });
      window.location.href = x.u;
    });
    if(today) today.addEventListener('click', function(){ var x = dayPick(); if(!x) return; track('cpd_sweet_of_the_day_click', { to: x.h }); window.location.href = x.u; });

    /* This month's most read: the handles set in the section, in order, drawn as cards under the tiles */
    var mostTile = idx.querySelector('[data-cpd-most]');
    var mostBox = idx.querySelector('[data-cpd-mostlist]');
    function buildMost(){
      if(!mostTile || !mostBox) return;
      var want = (idx.getAttribute('data-most') || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
      var byH = {}; all.forEach(function(x){ byH[x.h] = x; });
      var rows = want.map(function(h){ return byH[h]; }).filter(Boolean).slice(0, 5);
      if(!rows.length){ mostTile.hidden = true; return; }
      mostBox.querySelector('ol').innerHTML = rows.map(function(x){ return '<li>' + card(x) + '</li>'; }).join('');
      mostTile.addEventListener('click', function(e){ e.preventDefault(); mostBox.hidden = false; jumpTo(mostBox, null); });
    }

    /* UNDER THE BANNER, COMPACT (user 2026-09-16: "best compacted clean and theme matches design"): the sweet of the day
       pill, and one browse row whose tabs switch between decades, ways of making and story themes, all drawn from the
       feed. A photo is used once across the three tabs, and a mix's packshot (a .png) only when a value has no
       photograph of a sweet at all. */
    var photo = function(u, w){ return String(u || '').replace(/([?&])width=\d+/, '$1width=' + w); };
    function fillToday(d){
      if(!d) return;
      if(todayName) todayName.textContent = d.t;
      var img = idx.querySelector('[data-cpd-today-img]');
      if(img) img.innerHTML = d.i ? '<img src="' + esc(photo(d.i, 200)) + '" alt="" width="100" height="100" loading="lazy" decoding="async">' : '<span class="custom-cpd4q__ecard-init" aria-hidden="true">' + esc(d.t.charAt(0)) + '</span>';
      var link = idx.querySelector('[data-cpd-today-link]');
      if(link){
        link.href = d.u;
        link.addEventListener('click', function(){ track('cpd_sweet_of_the_day_click', { to: d.h }); });
      }
    }
    function buildBrowse(){
      var box = idx.querySelector('[data-cpd-browse]');
      if(!box) return;
      var row = box.querySelector('[data-cpd-bw-row]');
      var allA = box.querySelector('[data-cpd-bw-all]');
      var tabs = box.querySelectorAll('[data-cpd-bw-tab]');
      var map = {};
      try{ map = JSON.parse((idx.querySelector('[data-cpd-routemap]') || {}).textContent || '{}'); }catch(e){}
      var used = {};
      var key = function(u){ return String(u).split('/files/').pop().split('?')[0].replace(/\.[a-z]+$/i, '').replace(/(-sugar)?-free|-\d+$/g, ''); };
      var pick = function(list){
        var real = list.filter(function(x){ return x.i && !/\.png/i.test(x.i); });
        var pool = real.length ? real : list.filter(function(x){ return x.i; });
        for(var i = 0; i < pool.length; i++){ var k = key(pool[i].i); if(!used[k]){ used[k] = 1; return pool[i].i; } }
        return pool.length ? pool[0].i : '';
      };
      var data = {};
      ['decade', 'method', 'theme'].forEach(function(kind){
        var g = {};
        sweets.forEach(function(x){ [].concat((kind === 'decade' ? x.e : kind === 'method' ? x.m : x.th) || []).forEach(function(v){ if(v){ (g[v] = g[v] || []).push(x); } }); });
        var keys = Object.keys(g).sort(function(a, b){ return g[b].length - g[a].length; });
        var shown = keys.slice(0, 8);
        /* decades: 8 IN A ROW, the run of 8 with the most sweets (client 2026-10-01 "We are missing 1970s": the top 8
           by count skipped the 1970s and left a gap between 1960s and 1980s) */
        if(kind === 'decade'){
          var chrono = keys.slice().sort(function(a, b){ return parseInt(a, 10) - parseInt(b, 10); });
          var best = 0, bestN = -1;
          /* a run with no missing decade inside it (1950s, 1960s ... every 10 years) wins over a run with a gap */
          for(var s0 = 0; s0 + 8 <= chrono.length || s0 === 0; s0++){ var n0 = 0, gap = 0; for(var q0 = s0; q0 < s0 + 8 && q0 < chrono.length; q0++){ n0 += g[chrono[q0]].length; if(q0 > s0 && parseInt(chrono[q0], 10) - parseInt(chrono[q0 - 1], 10) !== 10) gap = 1; } n0 += gap ? 0 : 100000; if(n0 > bestN){ bestN = n0; best = s0; } }
          shown = chrono.slice(best, best + 8);
        }
        data[kind] = { total: keys.length, items: shown.map(function(v){ return { v: v, n: g[v].length, url: (map[kind] || {})[v] || '', src: pick(g[v]) }; }) };
      });
      var show = function(kind){
        var tab = null;
        each(tabs, function(t){ var on = t.getAttribute('data-cpd-bw-tab') === kind; t.setAttribute('aria-selected', on ? 'true' : 'false'); if(on) tab = t; });
        var d = data[kind];
        if(!tab || !d) return;
        /* the collection page circles (user 2026-09-17: "match as like this, animations etc"): the name only, the count
           in the tooltip; each circle rises in turn when a tab is chosen */
        row.innerHTML = d.items.map(function(x, n){
          var count = x.n + (x.n === 1 ? ' sweet' : ' sweets');
          return '<a class="custom-cpd4q__bw-i" style="--i:' + n + '" href="' + esc(x.url || tab.getAttribute('data-all')) + '" data-cpd-route="' + kind + '" title="' + esc(x.v + ', ' + count) + '">'
            + '<span class="custom-cpd4q__bw-ring"><span class="custom-cpd4q__bw-disc">'
            + (x.src ? '<img src="' + esc(photo(x.src, 240)) + '" alt="" width="120" height="120" loading="lazy" decoding="async">' : '<span class="custom-cpd4q__ecard-init" aria-hidden="true">' + esc(x.v.charAt(0)) + '</span>')
            + '</span></span><span class="custom-cpd4q__bw-t">' + esc(x.v) + '</span><span class="custom-cpd4q__vh">, ' + count + '</span></a>';
        }).join('');
        row.classList.remove('custom-cpd4q__bw-row--in'); void row.offsetWidth; row.classList.add('custom-cpd4q__bw-row--in');
        row.scrollLeft = 0;   /* a new tab starts at its first circle */
        if(allA){
          allA.href = tab.getAttribute('data-all');
          allA.setAttribute('data-cpd-route', kind);
          allA.textContent = (tab.getAttribute('data-all-text') || '').replace('[X]', d.total);
        }
      };
      each(tabs, function(t){
        var kind = t.getAttribute('data-cpd-bw-tab');
        if(!data[kind] || !data[kind].items.length){ t.hidden = true; return; }
        t.addEventListener('click', function(){ show(kind); track('cpd_browse_tab', { tab: kind }); });
      });
      show('decade');
    }

    /* SEARCH SUGGESTIONS (user 2026-09-16: "there should be customized suggested"). A panel under the box: before typing,
       five sweets to try (the sweet of the day and four more spread through the A to Z, so it changes daily and is the same for everyone);
       while typing, the best six matches ranked name first, a word in the name next, then anywhere in the name or the
       also known as, each with its photo and the matching letters picked out, and a See all row that takes the reader
       to the A to Z below. Arrow keys, Enter and Escape work; a click outside closes it. */
    var sq = idx.querySelector('[data-cpd-sq]');
    var sug = sq && sq.querySelector('[data-cpd-sug]');
    var qClear = sq && sq.querySelector('[data-cpd-qclear]');
    var sugOn = -1;
    var heroBox = sq && sq.closest('.custom-cpd4q__hero');
    function sugOpen(open){
      if(!sug) return;
      sug.hidden = !open;
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(heroBox) heroBox.classList.toggle('custom-cpd4q__hero--sug', open);
      if(!open){ sugOn = -1; q.removeAttribute('aria-activedescendant'); }
    }
    function mark(text, t){
      var i = t ? text.toLowerCase().indexOf(t) : -1;
      if(i < 0) return esc(text);
      return esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + t.length)) + '</mark>' + esc(text.slice(i + t.length));
    }
    function sugRow(x, t, n){
      var name = x.t.toLowerCase(), viaAka = t && name.indexOf(t) < 0 && (x.a || '').toLowerCase().indexOf(t) > -1;
      var sub = viaAka ? 'Also known as ' + mark(x.a, t) : esc(x.k || '');
      var meta = x.b ? (x.bt || 'Glossary') : (x.e || '');
      return '<a class="custom-cpd4q__sug-i" id="cpd-sug-' + n + '" role="option" aria-selected="false" href="' + esc(x.u) + '" data-h="' + esc(x.h) + '">'
        + '<span class="custom-cpd4q__sug-c">' + (x.i ? '<img src="' + esc(photo(x.i, 120)) + '" alt="" width="60" height="60" loading="lazy" decoding="async">' : '<span class="custom-cpd4q__ecard-init" aria-hidden="true">' + esc(x.t.charAt(0)) + '</span>') + '</span>'
        + '<span class="custom-cpd4q__sug-t"><b>' + mark(x.t, t) + '</b>' + (sub ? '<small>' + sub + '</small>' : '') + '</span>'
        + (meta ? '<span class="custom-cpd4q__sug-m">' + esc(meta) + '</span>' : '') + '</a>';
    }
    function sugDraw(){
      if(!sug || !all.length) return;
      var t = q.value.trim().toLowerCase(), html = '';
      if(qClear) qClear.hidden = !q.value;
      if(!t){
        var start = sweets.length ? Math.floor(Date.now() / 864e5) % sweets.length : 0, picks = [];
        var step = Math.max(1, Math.floor(sweets.length / 5));   /* spread across the A to Z, not five neighbours */
        for(var k = 0; k < Math.min(5, sweets.length); k++) picks.push(sweets[(start + k * step) % sweets.length]);
        html = '<p class="custom-cpd4q__sug-h">' + esc(sq.getAttribute('data-try')) + '</p>' + picks.map(function(x, n){ return sugRow(x, '', n); }).join('');
      }else{
        var scored = [];
        all.forEach(function(x){
          if(!matches(x, t)) return;
          var name = x.t.toLowerCase(), s = name.indexOf(t) === 0 ? 0 : (' ' + name).indexOf(' ' + t) > -1 ? 1 : name.indexOf(t) > -1 ? 2 : 3;
          scored.push([s + (x.b ? 0.5 : 0), x]);
        });
        scored.sort(function(a, b){ return a[0] - b[0] || (a[1].t < b[1].t ? -1 : 1); });
        if(!scored.length){
          html = '<p class="custom-cpd4q__sug-none">' + esc(sq.getAttribute('data-none').replace('[Q]', q.value.trim())) + '</p>';
        }else{
          html = scored.slice(0, 6).map(function(p, n){ return sugRow(p[1], t, n); }).join('')
            + '<button type="button" class="custom-cpd4q__sug-all" id="cpd-sug-all" role="option" aria-selected="false" data-cpd-sugall>'
            + esc(sq.getAttribute('data-all').replace('[X]', scored.length)) + '<svg viewBox="0 0 22 10" aria-hidden="true"><path d="M1 5h19M16 1.5 20 5l-4 3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        }
      }
      sug.innerHTML = html;
      sugOn = -1;
      sugOpen(true);
    }
    function sugMove(d){
      var opts = sug.querySelectorAll('[role="option"]');
      if(!opts.length) return;
      sugOn = (sugOn + d + opts.length) % opts.length;
      each(opts, function(o, n){ o.classList.toggle('is-active', n === sugOn); o.setAttribute('aria-selected', n === sugOn ? 'true' : 'false'); });
      q.setAttribute('aria-activedescendant', opts[sugOn].id);
      opts[sugOn].scrollIntoView({ block: 'nearest' });
    }
    function sugSeeAll(){
      sugOpen(false);
      clearTimeout(qT); term = q.value; render(); syncUrl();
      if(window.matchMedia('(max-width: 768px)').matches) q.blur();
      var first = list.querySelector('.custom-cpd4q__group') || emptyEl;
      if(first) jumpTo(first, lettersNav);
    }
    if(sq && sug && q){
      q.addEventListener('input', sugDraw);
      q.addEventListener('focus', sugDraw);
      q.addEventListener('click', function(){ if(sug.hidden) sugDraw(); });
      q.addEventListener('keydown', function(e){
        if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){ e.preventDefault(); if(sug.hidden) sugDraw(); sugMove(e.key === 'ArrowDown' ? 1 : -1); return; }
        if(e.key === 'Escape'){ if(!sug.hidden){ e.preventDefault(); sugOpen(false); } return; }
        if(e.key === 'Enter'){
          e.preventDefault();
          var act = sugOn > -1 ? sug.querySelectorAll('[role="option"]')[sugOn] : null;
          if(act){ act.click(); return; }
          if(q.value.trim()) sugSeeAll();
        }
      });
      /* keep the focus in the box while an option is pressed, so the panel is still there when the click lands */
      sug.addEventListener('mousedown', function(e){ e.preventDefault(); });
      sug.addEventListener('click', function(e){
        if(e.target.closest('[data-cpd-sugall]')){ sugSeeAll(); return; }
        var a = e.target.closest('.custom-cpd4q__sug-i');
        if(a) track('cpd_search_select', { q: q.value.trim(), to: a.getAttribute('data-h') });
      });
      if(qClear) qClear.addEventListener('click', function(){ q.value = ''; q.dispatchEvent(new Event('input')); q.focus(); });
      document.addEventListener('click', function(e){ if(!sug.hidden && !sq.contains(e.target)) sugOpen(false); });
      sq.addEventListener('focusout', function(e){ if(e.relatedTarget && !sq.contains(e.relatedTarget)) sugOpen(false); });
      if(qClear) qClear.hidden = !q.value;
    }

    if(params.get('q') && q){ q.value = params.get('q'); term = q.value; }
    ['c', 'd', 'e', 'th'].forEach(function(k){ if(params.get(k)) f[k] = params.get(k); });

    loadFeed(idx.getAttribute('data-feed')).then(function(items){
      all = items;
      sweets = items.filter(function(x){ return !x.b; });
      if(countEl){
        var ct = idx.getAttribute('data-count-text') || '';
        if(ct){ countEl.textContent = ct.replace('[X]', sweets.length); countEl.hidden = false; }
      }
      fillToday(dayPick());
      buildBrowse();
      if(sq && q && document.activeElement === q && q.value.trim()) sugDraw();
      buildFilters();
      buildMost();
      render();
      /* a link to a letter (an entry's breadcrumb) lands on it */
      var hash = window.location.hash.slice(1);
      if(hash){
        var el = document.getElementById(hash) || (/^cpd-[0-9]$/.test(hash) ? document.getElementById('cpd-num') : null);
        if(el) setTimeout(function(){ jumpTo(el, lettersNav, true); }, 60);
      }
    }).catch(function(){
      list.innerHTML = '';
      emptyEl.hidden = false;
    });
  }

  /* ================= ENTRY ================= */
  if(art){
    track('cpd_entry_view', { entry: pageHandle, name: art.getAttribute('data-name') || '', kind: art.getAttribute('data-kind') || '' });
    onceInView(art.querySelector('[data-cpd-bars]'), 'custom-cpd4q__dials', 0.4);   /* the neon dials sweep to their score */
    onceInView(art.querySelector('.custom-cpd4q__rel'), 'custom-cpd4q__rel', 0.2);

    var pn = art.querySelector('[data-cpd-pn]');
    if(pn) loadFeed(art.getAttribute('data-feed')).then(function(items){
      var bgEntry = art.getAttribute('data-kind') === 'background';
      var rows = items.filter(function(x){ return bgEntry ? x.b : !x.b; });
      var i = -1;
      for(var k = 0; k < rows.length; k++){ if(rows[k].h === pageHandle){ i = k; break; } }
      if(i < 0) return;
      var set = function(a, x){ if(!a || !x) return; a.href = x.u; a.querySelector('b').textContent = x.t; a.hidden = false; };
      set(pn.querySelector('[data-prev]'), rows[i - 1]);
      set(pn.querySelector('[data-next]'), rows[i + 1]);
      pn.hidden = false;
    }).catch(function(){});

    var buy = art.querySelector('[data-cpd-buy]');
    if(buy){
      var addB = buy.querySelector('[data-cpd-add]');
      var priceEl = buy.querySelector('[data-cpd-price]');
      var sizes = buy.querySelectorAll('.custom-cpd4q__abuy-size');
      var packs = buy.querySelectorAll('.custom-cpd4q__abuy-pack');
      var dd = buy.querySelector('[data-cpd-dd]');
      var ddBtn = dd && dd.querySelector('.custom-cpd4q__abuy-ddbtn');
      var ddCur = dd && dd.querySelector('[data-cpd-ddcur]');
      var ddOpts = dd ? dd.querySelectorAll('.custom-cpd4q__abuy-ddopt') : [];
      /* the sticky pill (user 2026-09-16): it mirrors the buy tile's size, price and button */
      var stk = art.querySelector('[data-cpd-sticky]');
      var stkAdd = stk && stk.querySelector('[data-cpd-stk-add]');
      var stkPrice = stk && stk.querySelector('[data-cpd-stk-price]');
      var stkSize = stk && stk.querySelector('[data-cpd-stk-size]');
      /* FILL UP, SAME AS THE PRODUCT PAGE (Arsalan 2026-09-29: "no filling animations here same like pdp"). A size
         with a real pack shot fills when it is picked and once when the tile first comes into view; the other
         sizes' photos are fetched after the page has loaded so a pick fills at once instead of waiting. */
      var fillPack = function(vid){
        each(packs, function(p){
          if(p.getAttribute('data-vid') !== vid || !p.classList.contains('custom-cpd4q__abuy-pack--shot')) return;
          if(window.c4uFill) window.c4uFill(p); else p.classList.add('c4u-fill--go');
        });
      };
      (function(){
        var media = buy.querySelector('.custom-cpd4q__abuy-media');
        var first = function(){ var on = null; each(packs, function(p){ if(!p.hidden) on = p; }); if(on) fillPack(on.getAttribute('data-vid')); };
        if(media && 'IntersectionObserver' in window){
          var io = new IntersectionObserver(function(es){ if(es[0].isIntersecting){ io.disconnect(); first(); } }, { threshold: 0.35 });
          io.observe(media);
        } else first();
        var warm = function(){ setTimeout(function(){ each(packs, function(p){ var im = p.querySelector('img'); if(im && im.loading === 'lazy') im.loading = 'eager'; }); }, 400); };
        if(document.readyState === 'complete') warm(); else window.addEventListener('load', warm, { once: true });
      })();
      /* one choice, two controls: the desktop pills and the phone dropdown both land here */
      var choose = function(vid){
        var b = null;
        each(sizes, function(o){ var on = o.getAttribute('data-vid') === vid; o.setAttribute('aria-checked', on ? 'true' : 'false'); if(on) b = o; });
        if(!b) return;
        each(ddOpts, function(o){ o.setAttribute('aria-selected', o.getAttribute('data-vid') === vid ? 'true' : 'false'); });
        if(ddCur) ddCur.textContent = b.textContent;
        each(packs, function(p){ p.hidden = p.getAttribute('data-vid') !== vid; });
        fillPack(vid);
        if(priceEl) priceEl.textContent = b.getAttribute('data-price');
        if(stkPrice) stkPrice.textContent = b.getAttribute('data-price');
        if(stkSize) stkSize.textContent = b.textContent;
        if(addB){
          var ok = b.getAttribute('data-avail') === 'true';
          addB.setAttribute('data-vid', vid);
          addB.disabled = !ok;
          addB.textContent = ok ? addB.getAttribute('data-label') : addB.getAttribute('data-sold');
          if(stkAdd){ stkAdd.disabled = !ok; stkAdd.textContent = addB.textContent; }
        }
      };
      each(sizes, function(b){ b.addEventListener('click', function(){ choose(b.getAttribute('data-vid')); }); });
      if(dd && ddBtn){
        var OPEN = 'custom-cpd4q__abuy-dd--open';
        var setOpen = function(open){
          dd.classList.toggle(OPEN, open);
          ddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if(open){ var sel = dd.querySelector('[aria-selected="true"]') || ddOpts[0]; if(sel) sel.focus({ preventScroll: true }); }
        };
        ddBtn.addEventListener('click', function(){ setOpen(!dd.classList.contains(OPEN)); });
        each(ddOpts, function(o){
          o.addEventListener('click', function(){ choose(o.getAttribute('data-vid')); setOpen(false); ddBtn.focus({ preventScroll: true }); });
        });
        document.addEventListener('click', function(e){ if(dd.classList.contains(OPEN) && !dd.contains(e.target)) setOpen(false); });
        dd.addEventListener('keydown', function(e){
          if(!dd.classList.contains(OPEN)) return;
          if(e.key === 'Escape'){ e.preventDefault(); setOpen(false); ddBtn.focus(); return; }
          if(e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
          e.preventDefault();
          var list = Array.prototype.slice.call(ddOpts), at = list.indexOf(document.activeElement);
          var next = list[Math.max(0, Math.min(list.length - 1, at + (e.key === 'ArrowDown' ? 1 : -1)))];
          if(next) next.focus();
        });
      }
      /* add to basket: the cart drawer opens on candy:cart:added, the same as everywhere else on the site */
      /* one add for both buttons, so the tile and the sticky pill never disagree about what is in the basket */
      var doAdd = function(source){
        if(!addB || addB.disabled || addB.dataset.busy) return;
        addB.dataset.busy = '1';
        var label = addB.getAttribute('data-label');
        var say = function(t){ addB.textContent = t; if(stkAdd) stkAdd.textContent = t; };
        /* a spinner on both buttons from the click until the basket answers (user 2026-09-16: "add loading animation
           when click until added") */
        var loading = function(on){ [addB, stkAdd].forEach(function(b){ if(!b) return; b.classList.toggle('is-loading', on); b.setAttribute('aria-busy', on ? 'true' : 'false'); }); };
        loading(true);
        track('cpd_buy_click', { entry: pageHandle, action: 'add_to_basket', variant: addB.getAttribute('data-vid'), source: source });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(addB.getAttribute('data-vid')), quantity: 1 }] })
        }).then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function(){ loading(false); document.dispatchEvent(new CustomEvent('candy:cart:added')); say('Added'); })
          .catch(function(){ loading(false); say('Try again'); })
          .then(function(){ setTimeout(function(){ say(label); delete addB.dataset.busy; }, 1200); });
      };
      if(addB) addB.addEventListener('click', function(){ doAdd('buy_tile'); });
      if(stkAdd) stkAdd.addEventListener('click', function(){ doAdd('sticky'); });
      /* the pill shows once the buy tile has scrolled off the top, and hides again when the tile or the footer is
         back on screen, so it never sits over the thing it copies or over the footer links */
      if(stk){
        var foot = document.querySelector('.shopify-section-group-footer-group');
        var stkTick = false;
        var evalStk = function(){
          stkTick = false;
          var past = buy.getBoundingClientRect().bottom < 0;
          /* the footer has to fill over half the screen before the pill goes: hiding it as soon as the footer's top edge
             appeared left 225 px of scrolling on a desktop entry, where the page below the buy tile is short (2026-09-16) */
          var atFoot = foot ? foot.getBoundingClientRect().top < window.innerHeight * 0.45 : false;
          var show = past && !atFoot;
          stk.classList.toggle('custom-cpd4q__stk--on', show);
          stk.setAttribute('aria-hidden', show ? 'false' : 'true');
        };
        window.addEventListener('scroll', function(){ if(!stkTick){ stkTick = true; requestAnimationFrame(evalStk); } }, { passive: true });
        window.addEventListener('resize', evalStk);
        evalStk();
      }
      /* the stash heart: the site's wishlist (assets/candy-wishlist.js) */
      var heart = buy.querySelector('[data-cpd-wish]');
      if(heart){
        var wh = heart.getAttribute('data-handle'), snap = null;
        try{ snap = JSON.parse(heart.getAttribute('data-snap')); }catch(e){ snap = { h: wh }; }
        var wire = function(){
          if(!window.candyWish){ heart.hidden = true; return; }
          window.candyWish.on(function(){ heart.setAttribute('aria-pressed', window.candyWish.has(wh) ? 'true' : 'false'); });
          heart.addEventListener('click', function(){ window.candyWish.toggle(snap || { h: wh }); track('cpd_buy_click', { entry: pageHandle, action: 'stash' }); });
        };
        if(window.candyWish) wire(); else window.addEventListener('load', wire);
      }
    }
  }

  /* ================= A BROWSE ROUTE VALUE: the rest of the list ================= */
  var rpage = document.querySelector('[data-cpd-routepage]');
  if(rpage){
    var rBox = rpage.querySelector('[data-cpd-ecards]');
    var rCount = rpage.querySelector('[data-cpd-rcount]');
    var rEmpty = rpage.querySelector('[data-cpd-rempty]');
    loadFeed(rpage.getAttribute('data-feed')).then(function(items){
      var rows = matchRoute(items, rpage.getAttribute('data-cpd-routepage'), rpage.getAttribute('data-cpd-value'));
      if(!rows.length || !rBox) return;
      if(rows.length > rBox.querySelectorAll('.custom-cpd4q__ecard').length) rBox.innerHTML = rows.map(card).join('');
      if(rCount){ rCount.textContent = countText(rpage, rows.length); rCount.hidden = false; }
      if(rEmpty) rEmpty.hidden = true;
    }).catch(function(){});
  }

  /* ================= A BROWSE ROUTE PAGE: the counts ================= */
  var hub = document.querySelector('[data-cpd-hub]');
  if(hub){
    loadFeed(hub.getAttribute('data-feed')).then(function(items){
      each(hub.querySelectorAll('[data-cpd-hubrow]'), function(li){
        var n = matchRoute(items, hub.getAttribute('data-cpd-hub'), li.getAttribute('data-cpd-hubrow')).length;
        if(!n) return;
        var el = li.querySelector('[data-cpd-hubn]');
        if(el) el.textContent = countText(hub, n);
        /* the button carried the number the page could count in Liquid, which stops at the first 50 of a list, so a
           row read "233 sweets" beside "See all 45" (user 2026-09-16). Both come from the feed now. */
        var all = li.querySelector('[data-cpd-huball]');
        if(all) all.textContent = (all.getAttribute('data-see-all') || 'See all [X]').replace('[X]', n);
      });
    }).catch(function(){});
  }

  /* ================= THE FOUR ROUTE CARDS, AND EMPTY VALUES =================
     The cards count every value the shop holds, but a route page only lists the values that have a sweet to show, so
     the card promised 18 decades against 17 rows (user 2026-09-16). The feed knows which values are really there, so
     the counts are corrected here and a chip pointing at an empty value is dropped rather than left to open a page
     saying "Nothing here yet". */
  var routeCounts = document.querySelector('[data-cpd-routen]');
  if(routeCounts){
    var feedEl = document.querySelector('[data-feed]');
    if(feedEl) loadFeed(feedEl.getAttribute('data-feed')).then(function(items){
      each(document.querySelectorAll('[data-cpd-routen]'), function(el){
        var kind = el.getAttribute('data-cpd-routen');
        var f = kind === 'decade' ? 'e' : kind === 'country' ? 'n' : kind === 'method' ? 'm' : 'th';
        var seen = {};
        items.forEach(function(x){
          var v = x[f];
          if(!v) return;
          (typeof v === 'string' ? [v] : v).forEach(function(one){ if(one) seen[one] = 1; });
        });
        var n = Object.keys(seen).length;
        if(n) el.textContent = n + ' ' + (el.getAttribute('data-cpd-routeword') || '');
      });
      /* a value chip with nothing behind it */
      var page = document.querySelector('[data-cpd-routepage]');
      if(page){
        var kind2 = page.getAttribute('data-cpd-routepage');
        each(document.querySelectorAll('.custom-cpd4q__rchip'), function(a){
          if(a.getAttribute('aria-current') === 'page') return;
          if(!matchRoute(items, kind2, (a.textContent || '').trim()).length) a.hidden = true;
        });
      }
    }).catch(function(){});
  }

  /* ================= GLOSSARY: the background entries ================= */
  var gl = document.querySelector('[data-cpd-glossary]');
  if(gl){
    var box = gl.querySelector('[data-cpd-gloss]');
    var gEmpty = gl.querySelector('[data-cpd-gloss-empty]');
    var types = (gl.getAttribute('data-types') || '').split(',').map(function(p){
      var kv = p.split(':'); return { k: (kv[0] || '').trim(), l: (kv[1] || kv[0] || '').trim() };
    }).filter(function(t){ return t.k; });
    /* COMPACT CARDS (user 2026-09-16): a glossary word has no photograph, so the big circles showed only a letter. Each
       word is a slim card now: a small icon for its group, the name, the hook and an arrow, and each group heading
       carries its count. */
    var svg = function(d){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; };
    var GICON = {
      Ingredient: svg('<path d="M9 3.5h6M10 3.5v5.2L5.2 17.3A2 2 0 0 0 7 20.5h10a2 2 0 0 0 1.8-3.2L14 8.7V3.5"/><path d="M7.5 14.5h9"/>'),
      Method: svg('<path d="M4.5 10.5h15l-1.4 8.2a2 2 0 0 1-2 1.8H7.9a2 2 0 0 1-2-1.8z"/><path d="M9 7.5c0-1.5 1-1.8 1-3.3M13 7.5c0-1.5 1-1.8 1-3.3"/>'),
      Place: svg('<path d="M12 21s-6.5-6.1-6.5-11.2a6.5 6.5 0 0 1 13 0C18.5 14.9 12 21 12 21z"/><circle cx="12" cy="9.8" r="2.4"/>'),
      Moment: svg('<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>'),
      More: svg('<path d="M12 6.6C10.2 5.3 7.6 4.7 4 4.9v12.6c3.6-.2 6.2.4 8 1.7 1.8-1.3 4.4-1.9 8-1.7V4.9c-3.6-.2-6.2.4-8 1.7zm0 0v12.6"/>')
    };
    var gcard = function(x){
      return '<a class="custom-cpd4q__gc" href="' + esc(x.u) + '"><span class="custom-cpd4q__gc-ico">' + (GICON[x.bt] || GICON.More) + '</span>'
        + '<span class="custom-cpd4q__gc-t"><b>' + esc(x.t) + '</b>' + (x.k ? '<small>' + esc(x.k) + '</small>' : '') + '</span>'
        + '<svg class="custom-cpd4q__gc-arr" viewBox="0 0 22 10" aria-hidden="true"><path d="M1 5h19M16 1.5 20 5l-4 3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
    };
    var group = function(label, rows){
      return '<section class="custom-cpd4q__ggroup"><h2 class="custom-cpd4q__ggroup-h">' + esc(label) + '<span class="custom-cpd4q__ggroup-n">' + rows.length + '</span></h2>'
        + '<div class="custom-cpd4q__gcards">' + rows.map(gcard).join('') + '</div></section>';
    };
    loadFeed(gl.getAttribute('data-feed')).then(function(items){
      var bg = items.filter(function(x){ return x.b; });
      var html = '', done = {};
      types.forEach(function(t){
        var rows = bg.filter(function(x){ return x.bt === t.k; });
        rows.forEach(function(x){ done[x.h] = 1; });
        if(rows.length) html += group(t.l, rows);
      });
      var rest = bg.filter(function(x){ return !done[x.h]; });
      if(rest.length) html += group('More', rest);
      box.innerHTML = html;
      gEmpty.hidden = bg.length > 0;
    }).catch(function(){ box.innerHTML = ''; gEmpty.hidden = false; });
  }

  /* ================= HISTORY ================= */
  var hi = document.querySelector('[data-cpd-history]');
  if(hi){
    var jump = hi.querySelector('[data-cpd-hjump]');
    var tocs = hi.querySelectorAll('[data-cpd-toc]');
    var chs = hi.querySelectorAll('.custom-cpd4q__hch');
    if(jump) jump.addEventListener('change', function(){
      var el = jump.value ? document.getElementById(jump.value) : null;
      if(el) el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
    /* the chapter being read is marked in the contents list and shown in the jump menu */
    if('IntersectionObserver' in window && chs.length){
      var hio = new IntersectionObserver(function(es){
        es.forEach(function(en){
          if(!en.isIntersecting) return;
          var id = en.target.id;
          each(tocs, function(a){ a.setAttribute('aria-current', a.getAttribute('href') === '#' + id ? 'true' : 'false'); });
          if(jump) jump.value = id;
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      each(chs, function(c){ hio.observe(c); });
    }
    /* scroll depth for GA4, once each at 25, 50, 75 and 100 percent of the page */
    var marks = [25, 50, 75, 100], sent = {}, ticking = false;
    var depth = function(){
      ticking = false;
      var r = hi.getBoundingClientRect(), total = r.height - window.innerHeight;
      var pct = total > 0 ? Math.min(100, Math.max(0, -r.top / total * 100)) : 100;
      marks.forEach(function(m){ if(pct >= m && !sent[m]){ sent[m] = 1; track('cpd_history_scroll', { percent: m }); } });
      if(sent[100]) window.removeEventListener('scroll', onScroll);
    };
    var onScroll = function(){ if(!ticking){ ticking = true; requestAnimationFrame(depth); } };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
